module.exports = __webpack_public_path__ + "img/retired-2018-garden.01e7e3b1.jpg";